/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AppendixResource } from './';
import {
    AppendixResourceFromJSON,
    AppendixResourceFromJSONTyped,
    AppendixResourceToJSON,
} from './';
import type { InvoicingMode } from './';
import {
    InvoicingModeFromJSON,
    InvoicingModeFromJSONTyped,
    InvoicingModeToJSON,
} from './';
import type { QuoteSource } from './';
import {
    QuoteSourceFromJSON,
    QuoteSourceFromJSONTyped,
    QuoteSourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ContractResource
 */
export interface ContractResource {
    /**
     * 
     * @type {string}
     * @memberof ContractResource
     */
    contractId: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResource
     */
    correlationId: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResource
     */
    quoteId: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResource
     */
    conversationId: string;
    /**
     * 
     * @type {Date}
     * @memberof ContractResource
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof ContractResource
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof ContractResource
     */
    type: ContractResourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ContractResource
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResource
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResource
     */
    descriptionFormat?: ContractResourceDescriptionFormatEnum;
    /**
     * 
     * @type {string}
     * @memberof ContractResource
     */
    currency: ContractResourceCurrencyEnum;
    /**
     * 
     * @type {AppendixResource}
     * @memberof ContractResource
     */
    appendix: AppendixResource;
    /**
     * 
     * @type {InvoicingMode}
     * @memberof ContractResource
     */
    invoicingMode: InvoicingMode;
    /**
     * 
     * @type {string}
     * @memberof ContractResource
     */
    paymentMode: ContractResourcePaymentModeEnum;
    /**
     * 
     * @type {QuoteSource}
     * @memberof ContractResource
     */
    quoteSource: QuoteSource;
}


/**
 * @export
 */
export const ContractResourceTypeEnum = {
    CostPlus: 'COST_PLUS',
    FixedPrice: 'FIXED_PRICE'
} as const;
export type ContractResourceTypeEnum = typeof ContractResourceTypeEnum[keyof typeof ContractResourceTypeEnum];

/**
 * @export
 */
export const ContractResourceDescriptionFormatEnum = {
    Simple: 'SIMPLE',
    Markdown: 'MARKDOWN'
} as const;
export type ContractResourceDescriptionFormatEnum = typeof ContractResourceDescriptionFormatEnum[keyof typeof ContractResourceDescriptionFormatEnum];

/**
 * @export
 */
export const ContractResourceCurrencyEnum = {
    Eur: 'EUR',
    Gbp: 'GBP',
    Usd: 'USD'
} as const;
export type ContractResourceCurrencyEnum = typeof ContractResourceCurrencyEnum[keyof typeof ContractResourceCurrencyEnum];

/**
 * @export
 */
export const ContractResourcePaymentModeEnum = {
    Prepayment: 'PREPAYMENT',
    InvoiceBeforePayment: 'INVOICE_BEFORE_PAYMENT'
} as const;
export type ContractResourcePaymentModeEnum = typeof ContractResourcePaymentModeEnum[keyof typeof ContractResourcePaymentModeEnum];


/**
 * Check if a given object implements the ContractResource interface.
 */
export function instanceOfContractResource(value: object): value is ContractResource {
    if (!('contractId' in value) || value['contractId'] === undefined) return false;
    if (!('correlationId' in value) || value['correlationId'] === undefined) return false;
    if (!('quoteId' in value) || value['quoteId'] === undefined) return false;
    if (!('conversationId' in value) || value['conversationId'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('appendix' in value) || value['appendix'] === undefined) return false;
    if (!('invoicingMode' in value) || value['invoicingMode'] === undefined) return false;
    if (!('paymentMode' in value) || value['paymentMode'] === undefined) return false;
    if (!('quoteSource' in value) || value['quoteSource'] === undefined) return false;
    return true;
}

export function ContractResourceFromJSON(json: any): ContractResource {
    return ContractResourceFromJSONTyped(json, false);
}

export function ContractResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractResource {
    if (json == null) {
        return json;
    }
    return {
        
        'contractId': json['contractId'],
        'correlationId': json['correlationId'],
        'quoteId': json['quoteId'],
        'conversationId': json['conversationId'],
        'startDate': (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'type': json['type'],
        'subject': json['subject'],
        'description': json['description'] == null ? undefined : json['description'],
        'descriptionFormat': json['descriptionFormat'] == null ? undefined : json['descriptionFormat'],
        'currency': json['currency'],
        'appendix': AppendixResourceFromJSON(json['appendix']),
        'invoicingMode': InvoicingModeFromJSON(json['invoicingMode']),
        'paymentMode': json['paymentMode'],
        'quoteSource': QuoteSourceFromJSON(json['quoteSource']),
    };
}

export function ContractResourceToJSON(value?: ContractResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'contractId': value['contractId'],
        'correlationId': value['correlationId'],
        'quoteId': value['quoteId'],
        'conversationId': value['conversationId'],
        'startDate': ((value['startDate']).toISOString().substring(0,10)),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString().substring(0,10)),
        'type': value['type'],
        'subject': value['subject'],
        'description': value['description'],
        'descriptionFormat': value['descriptionFormat'],
        'currency': value['currency'],
        'appendix': AppendixResourceToJSON(value['appendix']),
        'invoicingMode': InvoicingModeToJSON(value['invoicingMode']),
        'paymentMode': value['paymentMode'],
        'quoteSource': QuoteSourceToJSON(value['quoteSource']),
    };
}

